import SizesMixin from '@/mixins/Sizes'
import TimeMixin from '@/mixins/Time'

export default
{
    name: 'app-button-circle',

    props:
    {
        grayStrokeStyle: { type: String, default: 'rgba(255, 255, 255, 0.25)' },
        grayStart: { type: Number, default: 0 },
        grayLength: { type: Number, default: 0 },
        whiteStrokeStyle: { type: String, default: 'rgba(255, 255, 255, 1)' },
        whiteStart: { type: Number, default: 0 },
        whiteLength: { type: Number, default: 0 },
        yellowStrokeStyle: { type: String, default: 'rgba(255, 230, 0, 1)' },
        yellowStart: { type: Number, default: 0 },
        yellowLength: { type: Number, default: 0 }
    },

    watch:
    {
        grayStart: function()
        {
            this.circles.gray.start.target = this.grayStart * Math.PI * 2
        },

        grayLength: function()
        {
            this.circles.gray.length.target = this.grayLength * Math.PI * 2
        },

        whiteStart: function()
        {
            this.circles.white.start.target = this.whiteStart * Math.PI * 2
        },

        whiteLength: function()
        {
            this.circles.white.length.target = this.whiteLength * Math.PI * 2
        },

        yellowStart: function()
        {
            this.circles.yellow.start.target = this.yellowStart * Math.PI * 2
        },

        yellowLength: function()
        {
            this.circles.yellow.length.target = this.yellowLength * Math.PI * 2
        },

    },

    mixins:
    [
        SizesMixin,
        TimeMixin
    ],

    created()
    {
    },

    mounted()
    {
        // Set up
        this.$canvas = this.$refs.canvas
        this.context = this.$canvas.getContext('2d')
        this.size = null
        this.half = null
        this.resized = false

        // Circles
        this.circles = {}
        this.circles.lineWidth = 2

        // Gray circle
        this.circles.gray = {}
        this.circles.gray.strokeStyle = this.grayStrokeStyle

        this.circles.gray.start = {}
        this.circles.gray.start.value = this.grayStart * Math.PI * 2
        this.circles.gray.start.easing = 0.005
        this.circles.gray.start.rounded = this.grayStart * Math.PI * 2
        this.circles.gray.start.target = this.grayStart * Math.PI * 2

        this.circles.gray.length = {}
        this.circles.gray.length.value = this.grayLength * Math.PI * 2
        this.circles.gray.length.easing = 0.005
        this.circles.gray.length.rounded = this.grayLength * Math.PI * 2
        this.circles.gray.length.target = this.grayLength * Math.PI * 2

        // Gray yellow
        this.circles.yellow = {}
        this.circles.yellow.strokeStyle = this.yellowStrokeStyle

        this.circles.yellow.start = {}
        this.circles.yellow.start.value = this.yellowStart * Math.PI * 2
        this.circles.yellow.start.easing = 0.005
        this.circles.yellow.start.rounded = this.yellowStart * Math.PI * 2
        this.circles.yellow.start.target = this.yellowStart * Math.PI * 2

        this.circles.yellow.length = {}
        this.circles.yellow.length.value = this.yellowLength * Math.PI * 2
        this.circles.yellow.length.easing = 0.005
        this.circles.yellow.length.rounded = this.yellowLength * Math.PI * 2
        this.circles.yellow.length.target = this.yellowLength * Math.PI * 2

        // Gray white
        this.circles.white = {}
        this.circles.white.strokeStyle = this.whiteStrokeStyle

        this.circles.white.start = {}
        this.circles.white.start.value = this.whiteStart * Math.PI * 2
        this.circles.white.start.easing = 0.005
        this.circles.white.start.rounded = this.whiteStart * Math.PI * 2
        this.circles.white.start.target = this.whiteStart * Math.PI * 2

        this.circles.white.length = {}
        this.circles.white.length.value = this.whiteLength * Math.PI * 2
        this.circles.white.length.easing = 0.005
        this.circles.white.length.rounded = this.whiteLength * Math.PI * 2
        this.circles.white.length.target = this.whiteLength * Math.PI * 2

        this.onResize()

        // window.setInterval(() =>
        // {
        //     this.circles.gray.start.target = Math.random() * Math.PI * 2
        //     this.circles.gray.length.target = Math.random() * Math.PI * 2

        //     this.circles.white.start.target = Math.random() * Math.PI * 2
        //     this.circles.white.length.target = Math.random() * Math.PI * 2

        //     this.circles.yellow.start.target = Math.random() * Math.PI * 2
        //     this.circles.yellow.length.target = Math.random() * Math.PI * 2
        // }, 1000)
    },

    methods:
    {
        onResize()
        {
            const boundings = this.$el.getBoundingClientRect()

            this.size = Math.min(boundings.width, boundings.height)
            this.half = this.size * 0.5

            this.$canvas.width = this.size
            this.$canvas.height = this.size

            this.resized = true
        },

        onTick()
        {
            let changed = false

            if(this.resized)
            {
                this.resized = false
                changed = true
            }

            // Gray start
            this.circles.gray.start.value += (this.circles.gray.start.target - this.circles.gray.start.value) * this.time.delta * this.circles.gray.start.easing
            const grayStartRounded = Math.round(this.circles.gray.start.value * 1000) / 1000

            if(grayStartRounded !== this.circles.gray.start.rounded)
            {
                this.circles.gray.start.rounded = grayStartRounded
                changed = true
            }

            // Gray length
            this.circles.gray.length.value += (this.circles.gray.length.target - this.circles.gray.length.value) * this.time.delta * this.circles.gray.length.easing
            const grayLengthRounded = Math.round(this.circles.gray.length.value * 1000) / 1000

            if(grayLengthRounded !== this.circles.gray.length.rounded)
            {
                this.circles.gray.length.rounded = grayLengthRounded
                changed = true
            }

            // Yellow start
            this.circles.yellow.start.value += (this.circles.yellow.start.target - this.circles.yellow.start.value) * this.time.delta * this.circles.yellow.start.easing
            const yellowStartRounded = Math.round(this.circles.yellow.start.value * 1000) / 1000

            if(yellowStartRounded !== this.circles.yellow.start.rounded)
            {
                this.circles.yellow.start.rounded = yellowStartRounded
                changed = true
            }

            // Yellow length
            this.circles.yellow.length.value += (this.circles.yellow.length.target - this.circles.yellow.length.value) * this.time.delta * this.circles.yellow.length.easing
            const yellowLengthRounded = Math.round(this.circles.yellow.length.value * 1000) / 1000

            if(yellowLengthRounded !== this.circles.yellow.length.rounded)
            {
                this.circles.yellow.length.rounded = yellowLengthRounded
                changed = true
            }

            // White start
            this.circles.white.start.value += (this.circles.white.start.target - this.circles.white.start.value) * this.time.delta * this.circles.white.start.easing
            const whiteStartRounded = Math.round(this.circles.white.start.value * 1000) / 1000

            if(whiteStartRounded !== this.circles.white.start.rounded)
            {
                this.circles.white.start.rounded = whiteStartRounded
                changed = true
            }

            // White length
            this.circles.white.length.value += (this.circles.white.length.target - this.circles.white.length.value) * this.time.delta * this.circles.white.length.easing
            const whiteLengthRounded = Math.round(this.circles.white.length.value * 1000) / 1000

            if(whiteLengthRounded !== this.circles.white.length.rounded)
            {
                this.circles.white.length.rounded = whiteLengthRounded
                changed = true
            }

            // Did change
            if(changed)
            {
                this.context.clearRect(0, 0, this.size, this.size)

                // Draw
                // Gray circle
                this.context.strokeStyle = this.circles.gray.strokeStyle
                this.context.lineWidth = this.circles.lineWidth
                this.context.beginPath()
                this.context.arc(this.half, this.half, this.half - this.circles.lineWidth * 0.5, this.circles.gray.start.rounded, this.circles.gray.start.rounded + this.circles.gray.length.rounded)
                this.context.stroke()

                // Yellow circle
                this.context.strokeStyle = this.circles.yellow.strokeStyle
                this.context.lineWidth = this.circles.lineWidth
                this.context.beginPath()
                this.context.arc(this.half, this.half, this.half - this.circles.lineWidth * 0.5, this.circles.yellow.start.rounded, this.circles.yellow.start.rounded + this.circles.yellow.length.rounded)
                this.context.stroke()

                // White circle
                this.context.strokeStyle = this.circles.white.strokeStyle
                this.context.lineWidth = this.circles.lineWidth
                this.context.beginPath()
                this.context.arc(this.half, this.half, this.half - this.circles.lineWidth * 0.5, this.circles.white.start.rounded, this.circles.white.start.rounded + this.circles.white.length.rounded)
                this.context.stroke()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-button-circle/script.js